import { environment } from '../../environments/environment';

export default function locationPath(value: string | undefined): string {
    return environment.clientHost + '/' + `/${value}`.split('/').filter(Boolean).join('/');
}
